const BorderSpinner = () => {
  return <div className="spinner-border" />;
};

export default BorderSpinner;
